<template>
	<div class="container">
		<div class="page">
			<div class="report">
				<div class="row">
					<div class="cell border-right" style="width: 33.3%"><span>Style Number：{{design.style_no}}</span></div>
					<div class="cell border-right" style="width: 33.3%"><span>Style Name：</span>{{design.name}}</div>
					<div class="cell" style="width: 33.3%"><span>Category：</span>{{design.product_category_name}}</div>
				</div>
				<div class="wrap">
					<div class="left">
						<div class="kuanshitu cell">
							<h3 class="title">Style Image：</h3>
							<div class="image-list">
                                <template v-for="(v, k) in design.image_list">
                                    <template v-if="util.test_image(v)">
                                        <img :src="v" :key="k" alt="" class="image-item" v-viewer />
                                        <a :href="v" target="_blank">Download</a>
                                    </template>
                                    <template v-if="(typeof v === 'object' && util.test_image(v.raw))" >
                                        <img :src="v.raw" :key="k" alt="" class="image-item" v-viewer />
                                        <a :href="v.raw" target="_blank">Download</a>
                                    </template>
                                </template>
							</div>
                            <h3 class="title">Style File：</h3>
                            <template v-for="(v, k) in design.image_list">
                                <a v-if="(typeof v === 'object' && !util.test_image(v.raw))" target="_blank" :href="v.raw">{{v.raw_name}}</a>
                            </template>
						</div>
						<div class="mianliao-cell cell">
							<h3 class="title">Material：</h3>
							<div class="table">
								<table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Info</th>
                      <th>Color</th>
                      <th>Width/Weight</th>
                      <th>Component</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(v, k) in design.material" :key="`m` + k">
                      <td>{{ v.alias }}</td>
                      <td>
                        <div class="table-info">
                          <img
                            v-if="!!v.image"
                            :src="v.image"
                            alt=""
                            class="fa-img"
                            v-viewer
                          />
                          <div class="text">
                            <span class="fa-name">{{ v.fabric_name_cn }}</span>
                            <span class="fa-key">{{ v.fabric_key }}</span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="colors">
                            <img
                        class="color-image"
                        v-if="v.color_value"
                        :src="v.color_value"
                        v-viewer
                      />
                      <div class="color-name">{{ v.color_name_en }}</div>
                        </div>
                      </td>
                      <td>{{ v.width_wide }}</td>
                      <td>{{v.component_en}}</td>
                      <td>{{ v.desc }}</td>
                    </tr>
                    <template v-if="design.is_material_self">
                      <tr v-for="(item,index) in design.material_self" :key="'ms'+index">
                        <td>
                          <div style="display:flex;align-items:center;">
                          <span style="color:red;">Customer</span>
                          <span>{{ item.alias }}</span>
                        </div>
                        </td>
                        <td>
                        <div class="table-info">
                          <img
                            v-if="!!item.image"
                            :src="item.image"
                            alt=""
                            class="fa-img"
                            v-viewer
                          />
                          <div class="text">
                            <span class="fa-name">{{ item.fabric_name_cn }}</span>
                            <span class="fa-key">{{ item.fabric_key }}</span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="colors">
                            <img
                        class="color-image"
                        v-if="item.color_value"
                        :src="item.color_value"
                        v-viewer
                      />
                      <div class="color-name">{{ item.color_name_en }}</div>
                        </div>
                      </td>
                      <td>{{ item.width_wide }}</td>
                      <td>{{item.component}}</td>
                      <td>{{ item.desc }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
							</div>
						</div>
						<div class="fuliao-cell cell">
							<h3 class="title">Accessory：</h3>
							<div class="table">
								<table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Info</th>
                      <th>Color</th>
                      <th>Spec</th>
                      <th>Num</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(v, k) in design.accessory"
                    :key="`m` + k">
                      <td></td>
                      <td>
                        <div class="product-info">
                          <img  v-if="!!v.image"
                            :src="v.image"
                            alt=""
                            class="fa-img"
                            v-viewer />
                            <div class="text">
                              <span class="fa-name">{{ v.accessory_name }}</span>
                              <span class="fa-key">{{ v.accessory_sku }}</span>
                            </div>
                        </div>
                      </td>
                      <td>
                        <div class="fuliao-colors">
                          <img
                            class="fuliao-color"
                            v-if="v.color_value"
                            :src="v.color_value"
                            v-viewer
                          />
                          <div class="fuliao-color-name">{{ v.color_name_en }}</div>
                        </div>
                      </td>
                      <td>{{ v.measure_unit_en || '' }}</td>
                      <td>{{v.num}}</td>
                      <td>{{ v.desc }}</td>
                    </tr>
                    <template v-if="design.is_accessory_self">
                      <tr v-for="(v,k) in design.accessory_self" :key="`as`+k">
                        <td>
                          <span style="color:red;">客</span>
                        </td>
                        <td>
                        <div class="product-info">
                          <img  v-if="!!v.image"
                            :src="v.image"
                            alt=""
                            class="fa-img"
                            v-viewer />
                            <div class="text">
                              <span class="fa-name">{{ v.accessory_name }}</span>
                              <span class="fa-key">{{ v.accessory_sku }}</span>
                            </div>
                        </div>
                      </td>
                      <td>
                        <div class="fuliao-colors">
                          <img
                            class="fuliao-color"
                            v-if="v.color_value"
                            :src="v.color_value"
                            v-viewer
                          />
                          <div class="fuliao-color-name">{{ v.color_name_en }}</div>
                        </div>
                      </td>
                      <td>{{ v.measure_unit_en || '' }}</td>
                      <td>{{v.num}}</td>
                      <td>{{ v.desc }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>

							</div>
						</div>
					</div>
					<div class="right">
						<div class="kuanshishuoming cell">
							<h3 class="title">Style Description：</h3>
							<p style="margin: 20px 10px;">{{design.description}}</p>
						</div>
						<div class="banxing cell">
							<h3 class="title">Patter：</h3>
							<p>Type：{{design.pattern_type|get_pattern_type}}</p>
							<template v-for="(v, k) in design.pattern" >
								<template v-if="design.pattern_type===1">
									<a class="file-item" :href="v.path" target="_blank">{{ v.name }}</a>
								</template>
								<template v-if="design.pattern_type===2">
									<a class="file-item" :href="v.path" target="_blank">{{ v.name }}</a>
								</template>
								<template v-if="design.pattern_type===3">
									<p>Scene：{{v.c_scene}}</p>
									<p>Type：{{v.c_type}}</p>
									<p>Description：{{v.c_content}}</p>
								</template>
							</template>
						</div>
						<div class="yinhua cell">
							<h3 class="title">Tech Description：</h3>
							{{design.special_tech_name}}
							<div class="c-item" v-for="(v,k) in design.tech">
								<img :src="v.raw" alt="" v-viewer v-if="util.test_image(v.raw)" />
								<a target="_blank" :href="v.raw">{{v.raw_name}}</a>
								<p>Description：{{v.content}}</p>
							</div>
						</div>
						<div class="yinhua cell">
							<h3 class="title">Printing Image：</h3>
							<div class="c-item" v-for="(v,k) in design.yinhua">
								<img :src="v.raw" alt="" v-viewer v-if="util.test_image(v.raw)" />
								<a target="_blank" :href="v.raw">{{v.raw_name}}</a>
								<p>Width：{{v.x}}cm，Height:{{v.y}}cm</p>
								<p>Tech：{{v.tech_name}}，Color Num:{{v.color}}</p>
								<p>Description：{{v.content}}</p>
							</div>
						</div>
						<div class="yinhua cell">
							<h3 class="title">Embroidery Image：</h3>
							<div class="c-item" v-for="(v,k) in design.xiuhua">
								<img :src="v.raw" alt="" v-viewer v-if="util.test_image(v.raw)" />
								<a target="_blank" :href="v.raw">{{v.raw_name}}</a>
                                <p>Width：{{v.x}}cm，Height:{{v.y}}cm</p>
								<p>Tech：{{v.tech_name}}</p>
								<p>Description：{{v.content}}</p>
							</div>
						</div>
                        <div class="yinhua cell">
                            <h3 class="title">Other File：</h3>
                            <div class="c-item" v-for="(v,k) in design.other_file">
                                <a target="_blank" :href="v.path">{{v.name}}</a>
                            </div>
                        </div>
					</div>
				</div>
				<div class="cell border-top other-file-cell">
					<h3 class="title">Other Attachment：</h3>
					<div class="file-list">
						<a target="_blank" :href="v.path" class="file-item" v-for="(v,k) in design.other_file">
							{{v.name}}
						</a>
					</div>
				</div>
			</div>

		</div>

	</div>

</template>

<script>
    import {
        GetOrderByPoNo, CheckCode, GetDesignByUUID, GetDraftByUUID, GetOrderByCapture
    } from "@/api/index.js"
import util from '@/utils/util';
	export default {
		name: 'SummaryOuter',
		components: {

		},
		filters: {
			get_pattern_type(v) {
				if(v==1) {
					return '平台版型'
				} else if(v==2) {
					return '客供版型'
				} else if(v==3) {
					return '定制版型'
				} else {
					return ''
				}
			},
		},
		data() {
            return {
                util: util,
                design: {
                    image_list: [],
                    tech: {}
                },
                from: 'design',
            };
		},
        computed: {
            admin_memo() {
                let obj = {
                    memo: '',
                    file: []
                }
                if(this.design.ord) {
                    obj = this.design.ord.admin_memo
                }
                return obj
            },
        },
		beforeRouteEnter (to, from, next) {
			next(vm => {
				// 通过 `vm` 访问组件实例
				vm.$emit('showHeader', false)
				vm.$emit('showFooter', false)
			})
		},
		mounted() {
            if(this.$route.query.from) {
                this.from = this.$route.query.from
            }

            if(this.$route.query.code) {
                CheckCode({code: this.$route.query.code}).then(() => {
                    return GetOrderByPoNo({
                        po_no: this.$route.query.po_no
                    })
                }).then(response => {
                    this.design = response.data
                }).catch((res)=>{
                    this.$layer.msg(res.msg)
                })
            } else if(this.from == 'detail') {
                GetOrderByCapture({
                    uuid: this.$route.query.uuid
                }).then(response => {
                    this.design = response.data
                }).catch((res)=>{
                    this.$layer.msg(res.msg)
                })
            } else if(this.$route.query.uuid) {
                if(this.from == 'design') {
                    GetDesignByUUID({
                        uuid: this.$route.query.uuid
                    }).then(response => {
                        this.design = response.data
                    }).catch((res)=>{
                        this.$layer.msg(res.msg)
                    })
                }
                if(this.from == 'draft') {
                    GetDraftByUUID({
                        uuid: this.$route.query.uuid
                    }).then(response => {
                        this.design = response.data
                    }).catch((res)=>{
                        this.$layer.msg(res.msg)
                    })
                }
            }
		},
		methods: {

		},

	}
</script>

<style lang="scss" scoped>
	.container {
		background: #F6F7FA;
		padding: 30px 0 150px 0;
		.page {
			width: 1200px;
			margin: 20px auto;
			background: white;
			padding: 40px 50px ;
			border-radius: 5px;
			.big-title {
				color: #333333;
				padding-bottom: 20px;
				font-size: 24px;
				text-align: center;
			}
			.title {
				color: #333333;
				border-left: 3px solid #FA3D5A;
				font-size: 14px;
				margin: 10px 0;
				padding-left: 8px;
				height: 15px;
				line-height: 15px;
			}
			.report {
				border: 1px solid #808080;
				.cell {
					padding: 15px 20px;
					/*border-top: 1px solid #808080;*/
					border-bottom: 1px solid #808080;
					font-size: 14px;
				}
				.border-top {
					border-top: 1px solid #808080;
				}
				.border-right {
					border-right: 1px solid #808080;
				}
				.border-right-no {
					border-right: none !important;
				}
				.border-bottom-no {
					border-bottom: none !important;
				}

				.row {
					display: flex;
					align-items: center;
					width: 100%;
					height: 50px;
					.cell {
						color: #666;
						span {
							font-weight: bold;
							color:#333;
						}
					}
				}
				.wrap {
					display: flex;
					flex-wrap: nowrap;
					.left {
						width: 720px;
						border-right: 1px solid #808080;
						.kuanshitu {
							.image-list {
								padding: 16px 0;
								display: flex;
								flex-wrap: wrap;
								.image-item {
									width: 180px;
									height: 180px;
									margin: 10px 5px;
									border: 1px solid #EBEBEB;
									object-fit: contain;
								}
							}
						}
						.gongyishuoming {
							.left {
								width: 260px;
								height: 305px;
								object-fit: contain;
							}
							.right {
								padding: 10px 20px;
							}
						}
						.mianliao-cell {
							table {
              width: 100%;
              border-collapse: collapse;
              font-size: 14px;
              table-layout: fixed;
              border:1px solid #e5e5e5;
            }

            tr{
              border-bottom:1px solid #e5e5e5;
            }

            th:first-child,
            td:first-child{
              width:75px;
            }
            th:nth-child(2),
            td:nth-child(2){
              width:225px;
              text-align:left;
              overflow:hidden;
              .table-info{
                display:flex;
                align-items:center;
                column-gap:3px;
                width:100%;
                font-size:12px;

                .fa-img{
                  width: 60px;
                  height: 60px;
                  object-fit: contain;
                }
                .text{
                  display:flex;
                  align-content:space-around;
                  align-items:center;
                  flex-wrap:wrap;
                  .fa-name{
                    width:100%;
                    font-weight:bold;
                  }
                  .fa-key{
                    width:100%;
                  }
                }
              }
            }
            td:nth-child(4),
            th:nth-child(4){
              width:80px;
            }
            th,
            td {
              // border: 1px solid #ddd;
              padding: 8px;
              width:auto;
              min-width:150px;
              max-width:160px;
              text-align:center;
              .colors{
                display:flex;
                align-items:center;
                justify-content:center;
                column-gap:3px;
                .color-image{
                  width:40px;
                  height:40px;
                }
                .color-name{
                  font-size:12px;
                }
              }
            }
						}
						.fuliao-cell {
							table {
              width: 100%;
              border-collapse: collapse;
              font-size: 14px;
              table-layout: fixed;
              border:1px solid #e5e5e5;
            }

            tr{
              border-bottom:1px solid #e5e5e5;
            }

            th:first-child,
            td:first-child{
              width:75px;
            }
            th:nth-child(2),
            td:nth-child(2){
              width:225px;
              text-align:left;
              overflow:hidden;
              .product-info{
                display:flex;
                align-items:center;
                column-gap:3px;
                width:100%;
                font-size:12px;

                .fa-img{
                  width: 60px;
                  height: 60px;
                  object-fit: contain;
                }
                .text{
                  display:flex;
                  align-content:space-around;
                  align-items:center;
                  flex-wrap:wrap;
                  .fa-name{
                    width:100%;
                    font-weight:bold;
                  }
                  .fa-key{
                    width:100%;
                  }
                }
              }
            }
            td:nth-child(4),
            th:nth-child(4){
              width:80px;
            }
            th,
            td {
              // border: 1px solid #ddd;
              padding: 8px;
              width:auto;
              min-width:150px;
              max-width:160px;
              text-align:center;
              .fuliao-colors{
                display:flex;
                align-items:center;
                justify-content:center;
                column-gap:3px;
                .fuliao-color{
                  width:40px;
                  height:40px;
                }
                .fuliao-color-name{
                  font-size:12px;
                }
              }
            }
						}
					}
					.right {
						width: 380px;
						.file-item {
							display: block;
							margin: 10px 0;
						}
						.c-item {
							display: flex;
							flex-wrap: wrap;
							align-items: center;
							justify-content: left;
							margin: 10px 0;
							img {
								width: 45px;
								height: 45px;
								margin-right: 20px;
								object-fit: contain;
							}
							span {

							}
							p {
								width: 100%;
								margin-top: 10px;
								padding: 10px;
								background: #FAFAFA;
								border-radius: 5px;
							}
						}

					}
				}
			}

			.other-file-cell {
				.file-list {
					display: flex;
					flex-wrap: wrap;
					justify-content: flex-start;
					align-items: center;
					.file-item {
						width: 330px;
						height: 42px;
						line-height: 42px;
						background: #FAFAFA;
						padding: 0 10px;
						margin: 5px 10px;
					}
				}
			}
		}

	}

</style>
